export default __webpack_public_path__ + "static/media/logo.98d0d8b2.png";